// src/components/Footer.js
import React, { useState, useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { contactInfoAPI } from '../services/api';

const Footer = () => {
    const [contactInfo, setContactInfo] = useState(null);

    useEffect(() => {
        const fetchContactInfo = async () => {
            try {
                const data = await contactInfoAPI.get();
                setContactInfo(data);
            } catch (error) {
                setContactInfo({
                    facebookUrl: 'https://www.facebook.com/a.angelkoska15/',
                    instagramUrl: 'https://www.instagram.com/angelkoska.fitness/',
                    linkedinUrl: 'https://linkedin.com',
                });
            }
        };
        fetchContactInfo();
    }, []);

    return (
        <Box component="footer" sx={{
            backgroundColor: '#2b2b2b', color: 'white',
            py: 4, borderTop: '3px solid #ff7eb9'
        }}>
            <Container maxWidth="lg">
                <Box sx={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    flexDirection: { xs: 'column', md: 'row' }, gap: 3,
                    textAlign: { xs: 'center', md: 'left' }
                }}>
                    {/* Logo */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box
                            component="img"
                            src="/Logo.png"
                            alt="Logo"
                            sx={{ height: 54, width: 180, objectFit: 'contain' }}
                        />
                    </Box>

                    {/* Socijalni mrezhi */}
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        {contactInfo?.facebookUrl && (
                            <Box
                                component="img"
                                src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/facebook.svg"
                                alt="Facebook"
                                onClick={() => window.open(contactInfo.facebookUrl, '_blank')}
                                sx={{
                                    width: 28, height: 28, filter: 'invert(1)', cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    '&:hover': { filter: 'invert(0.5) sepia(1) saturate(5) hue-rotate(180deg)', transform: 'scale(1.2)' }
                                }}
                            />
                        )}
                        {contactInfo?.instagramUrl && (
                            <Box
                                component="img"
                                src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/instagram.svg"
                                alt="Instagram"
                                onClick={() => window.open(contactInfo.instagramUrl, '_blank')}
                                sx={{
                                    width: 28, height: 28, filter: 'invert(1)', cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    '&:hover': { filter: 'invert(0.3) sepia(1) saturate(5) hue-rotate(290deg)', transform: 'scale(1.2)' }
                                }}
                            />
                        )}
                    </Box>

                    {/* Copyright */}
                    <Box sx={{ flex: 1, textAlign: 'center' }}>
                        <Typography variant="body1" sx={{ color: '#ffffff', fontWeight: 'bold', fontSize: { xs: '0.9rem', md: '1rem' } }}>
                            © 2026 BODYLAB BY ANAMARIJA. Сите права се задржани.
                        </Typography>
                    </Box>

                    {/* Disclaimer */}
                    <Box>
                        <Typography variant="caption" sx={{ color: '#999999', fontSize: { xs: '0.7rem', md: '0.8rem' }, display: 'block', textAlign: { xs: 'center', md: 'right' } }}>
                            Секоја неовластена употреба на материјалите е забранета<br />
                            и ќе се казни согласно важечките закони.
                        </Typography>
                    </Box>
                </Box>

                {/* ДОЛЕН ДЕЛ - СРЕДЕН РАСПОРЕД */}
                <Box sx={{
                    mt: 3, pt: 2,
                    borderTop: '1px solid #444444',
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: '1fr auto 1fr' },
                    alignItems: 'center',
                    gap: 2
                }}>
                    {/* Празен простор лево за баланс на десктоп */}
                    <Box sx={{ display: { xs: 'none', md: 'block' } }} />

                    {/* ЦЕНТАР */}
                    <Typography variant="caption" sx={{ color: '#777777', fontSize: '0.75rem', textAlign: 'center' }}>
                        🏋️‍♂️ Направено со љубов за фитнес заедницата 🏋️‍♂️
                    </Typography>

                    {/* ДЕСНО */}
                    <Typography
                        variant="caption"
                        onClick={() => window.open('https://lynxriselabs.com/', '_blank')}
                        sx={{
                            color: '#81c784',
                            fontSize: '0.75rem',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            textAlign: { xs: 'center', md: 'right' },
                            '&:hover': { color: '#ffffff', textDecoration: 'underline' }
                        }}
                    >
                        Created by LynxRise Labs
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;